import React from 'react';
import { WithWistiaContext } from 'utils/WistiaContext';
import CallToAction from 'components/Contentful/ContentfulCallToAction';
import WistiaVideoModal from '../components/WistiaVideoModal';
import { PlayCtaPopoverContainer } from './styles';

const PlayCtaPopover = ({ cta, isPlaying, setIsPlaying, toggleIsModalOpen }) => {
  return (
    <PlayCtaPopoverContainer className="wistia-video--wrapper">
      <CallToAction
        {...cta}
        isCtaPopoverVideo={false}
        wistiaVideo={false}
        setIsPlaying={setIsPlaying}
        isPlaying={isPlaying}
        toggleIsVideoModalOpen={toggleIsModalOpen}
      />
      <WistiaVideoModal />
    </PlayCtaPopoverContainer>
  );
};

export default WithWistiaContext(PlayCtaPopover);
